$(document).ready(function() {
  // BFCM: on phones the product page shows one large image at a time. The feature image (the one that used to sit beside the slider) becomes the first slide and the first thumbnail.
  if (window.innerWidth < 750) {
    var $feat = $('.product__media-wrapper').children('.width-42').not(':has(.main_product_images_block)').first();
    var $featImg = $feat.find('img').first();
    var featSrc = $featImg.attr('src');
    if (featSrc) {
      var cleanUrl = function(u) { return (u || '').split('?')[0]; };
      var isDuplicate = false;
      $('.main_product_images_block .slide img').each(function() {
        if (cleanUrl($(this).attr('src')) === cleanUrl(featSrc)) { isDuplicate = true; }
      });
      if (!isDuplicate) {
        var $slide = $('<div class="slide"></div>').append($('<img>').attr({ src: featSrc, alt: $featImg.attr('alt') || '' }));
        var $thumb = $('<div class="thumb_product_image_cell"></div>').append($('<img>').attr({ src: featSrc, alt: '' }));
        $('.main_product_images_block').prepend($slide);
        $('.thumb_product_images_block').prepend($thumb);
      }
    }
    $feat.addClass('ciroa-feature');
  }

  // Initialize the main product image slider
  var $mainSlider = $('.main_product_images_block').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: false,
    arrows: true,
    prevArrow: '<span class="prev_arrow arrows"> <svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow"></path></svg></span>',
    nextArrow: '<span class="next_arrow arrows"> <svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></span>',
    asNavFor: '.thumb_product_images_block'
  });

  // Initialize the thumbnail slider (vertical on desktop, a row under the image on phones)
  var $thumbSlider = $('.thumb_product_images_block').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    vertical: true,
    verticalSwiping: true,
    infinite: false,
    asNavFor: '.main_product_images_block',
    dots: false,
    arrows: false,
    responsive: [
      {
        breakpoint: 749,
        settings: {
          vertical: false,
          verticalSwiping: false,
          slidesToShow: 5,
          slidesToScroll: 1
        }
      }
    ]
  });

  // Sync the active class with the current slide
  function updateActiveThumbnail(currentSlide) {
    var $thumbnails = $('.thumb_product_images_block .slick-slide');
    $thumbnails.removeClass('active-slide');
    var $currentThumb = $thumbnails.eq(currentSlide);
    $currentThumb.addClass('active-slide');
  }

  $mainSlider.on('afterChange', function(event, slick, currentSlide) {
    updateActiveThumbnail(currentSlide);
  });

  $thumbSlider.on('afterChange', function(event, slick, currentSlide) {
    updateActiveThumbnail(currentSlide);
  });

  // Set initial active slide class
  var initialSlideIndex = $mainSlider.slick('slickCurrentSlide');
  updateActiveThumbnail(initialSlideIndex);

  // Add click event to thumbnails
  $('.thumb_product_images_block').on('click', '.slick-slide', function() {
    var index = $(this).data('slick-index');
    $mainSlider.slick('slickGoTo', index);
    updateActiveThumbnail(index);
  });
});

// BFCM: product page tabs (Hero ingredients, How to use, ...). On desktop open the first tab by default, also inside the theme editor where sections load after the page is ready.
(function () {
  function ciroaOpenFirstTab() {
    if (window.innerWidth < 750) return;
    if (!document.querySelector('.tabcontent-cus')) return;
    if (document.querySelector('.tablinks-cus.active')) return;
    var first = document.getElementById('tab-cus-active') || document.querySelector('.tablinks-cus');
    if (first && typeof window.openTab === 'function') first.click();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ciroaOpenFirstTab);
  } else {
    ciroaOpenFirstTab();
  }
  window.addEventListener('load', ciroaOpenFirstTab);
  document.addEventListener('shopify:section:load', ciroaOpenFirstTab);
})();

// BFCM: product page buy area. Order is title, type, price, reviews, size or option, Add to cart, then Afterpay and shipping. Clear size steps from the title down to the price, and a full width button.
(function () {
  var P = 'body .product__info-container ';
  var css = '' +
    P + '.product__title.custom-18 { width: 100% !important; margin: 0 auto 8px !important; }' +
    P + '.product__title.custom-18 .custom-18, ' + P + '.product__title.custom-18 .custom-18 a, ' + P + '.product__title.custom-18 a { font-size: 30px !important; line-height: 1.2 !important; display: block; }' +
    P + 'p.product__text { font-size: 1.3rem !important; letter-spacing: 0.14em !important; margin: 0 0 12px !important; }' +
    P + '.price .price-item, ' + P + '.price__container .price-item { font-size: 2.8rem !important; line-height: 1.1 !important; }' +
    P + '.price .price-item--regular s, ' + P + '.price s.price-item { font-size: 1.8rem !important; }' +
    P + '.product__tax, ' + P + '.product__tax * { font-size: 1.2rem !important; line-height: 1.4 !important; letter-spacing: 0.02em !important; }' +
    P + '.product__tax { margin: 6px 0 16px !important; }' +
    P + '.product-form__buttons { max-width: none !important; width: 100% !important; }' +
    P + 'product-form, ' + P + '.product-form { display: block; width: 100%; margin: 14px 0 6px !important; }' +
    P + '.product-form__submit.button { width: 100% !important; min-height: 56px; font-size: 1.6rem !important; }' +
    P + '[id$="payments_messaging_ic9KAw"] { text-align: center; margin: 4px 0 14px !important; }' +
    P + '[id$="payments_messaging_ic9KAw"] * { font-size: 1.3rem !important; }';
  var style = document.createElement('style');
  style.setAttribute('data-ciroa', 'pdp-buy-area');
  style.appendChild(document.createTextNode(css));
  document.head.appendChild(style);

  function childOf(container, el) {
    while (el && el.parentNode !== container) { el = el.parentNode; }
    return el;
  }
  function ciroaReorderBuyArea() {
    var container = document.querySelector('.product__info-container');
    if (!container || container.getAttribute('data-ciroa-order') === '1') return;
    var buy = childOf(container, container.querySelector('.product-form__buttons, product-form'));
    var picker = childOf(container, container.querySelector('variant-selects, variant-radios'));
    var afterpay = childOf(container, container.querySelector('[id$="payments_messaging_ic9KAw"]'));
    if (!buy) return;
    if (picker && picker !== buy) { container.insertBefore(picker, buy); }
    if (afterpay && afterpay !== buy) { buy.parentNode.insertBefore(afterpay, buy.nextSibling); }
    container.setAttribute('data-ciroa-order', '1');
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ciroaReorderBuyArea);
  } else {
    ciroaReorderBuyArea();
  }
  window.addEventListener('load', ciroaReorderBuyArea);
  document.addEventListener('shopify:section:load', ciroaReorderBuyArea);
})();

// BFCM: shipping and minis line under the price, Notify me on sold out cards, solid Check out button, best sellers in the empty cart.
(function () {
  var css = '' +
    'body .ciroa-perks { margin: 0 0 18px; padding: 12px 16px; background: #FBDDE4; border-radius: 12px; color: #545454; font-family: \'Century Gothic\', CenturyGothic, \'Apple Gothic\', AppleGothic, var(--font-body-family), Questrial, sans-serif; font-size: 1.4rem; line-height: 1.5; }' +
    'body .ciroa-perks p { margin: 0; font-size: 1.4rem; }' +
    'body .ciroa-perks p + p { margin-top: 4px; }' +
    'body .ciroa-perks strong { font-weight: 700; }' +
    'body a.ciroa-notify { display: flex; align-items: center; justify-content: center; width: 100%; min-height: 4.4rem; box-sizing: border-box; padding: 1rem 1.2rem; background: #58595b; color: #fff; border-radius: 14px; text-decoration: none; font-size: 1.4rem; font-weight: 600; letter-spacing: 0.06em; text-transform: uppercase; transition: background .2s ease; }' +
    'body a.ciroa-notify:hover { background: #3f4042; color: #fff; }' +
    '@media (max-width: 749px) { body a.ciroa-notify { font-size: 1.2rem; min-height: 4rem; } }' +
    'body #CartDrawer-Checkout, body .cart__checkout-button.button, body button#checkout { background: #58595b !important; background-image: none !important; color: #fff !important; border: none !important; border-radius: 14px !important; box-shadow: none !important; min-height: 5.2rem; text-transform: uppercase; letter-spacing: 0.08em; font-weight: 600; opacity: 1; }' +
    'body #CartDrawer-Checkout::before, body #CartDrawer-Checkout::after, body .cart__checkout-button.button::before, body .cart__checkout-button.button::after, body button#checkout::before, body button#checkout::after { display: none !important; box-shadow: none !important; }' +
    'body #CartDrawer-Checkout:hover, body .cart__checkout-button.button:hover, body button#checkout:hover { background: #3f4042 !important; }' +
    'body #CartDrawer-Checkout[disabled] { background: #bdbdbd !important; }' +
    '.ciroa-empty-best { padding: 8px 20px 28px; font-family: \'Century Gothic\', CenturyGothic, \'Apple Gothic\', AppleGothic, var(--font-body-family), Questrial, sans-serif; color: #545454; }' +
    '.ciroa-empty-best h3 { font-family: \'Shrikhand-Regular\', \'Shrikhand\', serif; text-transform: lowercase; font-weight: 400; color: #E895A5; font-size: 2.4rem; text-align: center; margin: 8px 0 16px; }' +
    '.ciroa-empty-best ul { list-style: none; margin: 0; padding: 0; display: grid; grid-template-columns: 1fr 1fr; gap: 14px; }' +
    '.ciroa-empty-best li { margin: 0; padding: 0; width: auto; max-width: none; }' +
    '.ciroa-empty-best .quick-add, .ciroa-empty-best .card__badge, .ciroa-empty-best .product-card-wrapper .card__content .rating { display: none !important; }' +
    '.ciroa-empty-best .card__heading, .ciroa-empty-best .card__heading a { font-size: 1.3rem !important; line-height: 1.3 !important; }';
  var style = document.createElement('style');
  style.setAttribute('data-ciroa', 'bfcm-extras');
  style.appendChild(document.createTextNode(css));
  document.head.appendChild(style);

  // 1. Shipping and minis line under the price on product pages
  function addPerks() {
    if (document.querySelector('.ciroa-perks')) return;
    var container = document.querySelector('.product__info-container');
    if (!container) return;
    var anchor = container.querySelector('.product__tax') || container.querySelector('.price');
    if (!anchor) return;
    var country = (window.Shopify && Shopify.country) || '';
    var html = '';
    if (country === 'AU') {
      html = '<p><strong>Free shipping</strong> over $60</p><p><strong>3 free minis</strong> with purchases over $50</p>';
    } else if (country === 'NZ') {
      html = '<p><strong>Free shipping</strong> over $80</p>';
    } else if (country === 'GB') {
      html = '<p><strong>Free shipping</strong> over £30</p>';
    }
    if (!html) return;
    var box = document.createElement('div');
    box.className = 'ciroa-perks';
    box.innerHTML = html;
    var target = anchor.closest('.product__tax') || anchor;
    while (target.parentNode && target.parentNode !== container) { target = target.parentNode; }
    container.insertBefore(box, target.nextSibling);
  }

  // 2. Sold out cards become Notify me, linking to the product page where the back in stock form lives
  function fixSoldOutCards() {
    var buttons = document.querySelectorAll('.product-card-wrapper .quick-add__submit[disabled]');
    for (var i = 0; i < buttons.length; i++) {
      var btn = buttons[i];
      if (!/sold\s*out/i.test(btn.textContent)) continue;
      var card = btn.closest('.product-card-wrapper');
      var link = card && card.querySelector('a.full-unstyled-link');
      var holder = btn.closest('product-form') || btn.closest('form') || btn;
      if (!link || !holder || !holder.parentNode) continue;
      var a = document.createElement('a');
      a.className = 'ciroa-notify';
      a.href = link.getAttribute('href');
      a.textContent = 'Notify me';
      holder.parentNode.replaceChild(a, holder);
    }
  }

  // 3. Best sellers in the empty cart drawer
  var loadingBest = false;
  function addEmptyCartBest() {
    var inner = document.querySelector('cart-drawer.is-empty .drawer__inner-empty');
    if (!inner || inner.querySelector('.ciroa-empty-best') || loadingBest) return;
    loadingBest = true;
    fetch('/collections/homepage-best-sellers')
      .then(function (r) { return r.text(); })
      .then(function (txt) {
        var doc = new DOMParser().parseFromString(txt, 'text/html');
        var items = doc.querySelectorAll('#product-grid > li');
        if (!items.length || inner.querySelector('.ciroa-empty-best')) return;
        var wrap = document.createElement('div');
        wrap.className = 'ciroa-empty-best';
        wrap.innerHTML = '<h3>best sellers</h3><ul></ul>';
        var ul = wrap.querySelector('ul');
        for (var i = 0; i < items.length && i < 4; i++) { ul.appendChild(document.importNode(items[i], true)); }
        inner.appendChild(wrap);
      })
      .catch(function () {})
      .then(function () { loadingBest = false; });
  }

  var queued = false;
  function run() {
    queued = false;
    addPerks();
    fixSoldOutCards();
    addEmptyCartBest();
  }
  function schedule() {
    if (queued) return;
    queued = true;
    (window.requestAnimationFrame || setTimeout)(run);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }
  window.addEventListener('load', schedule);
  document.addEventListener('shopify:section:load', schedule);
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
})();
